import { render, staticRenderFns } from "./subServerTable.vue?vue&type=template&id=45357d79&scoped=true&"
import script from "./subServerTable.vue?vue&type=script&lang=js&"
export * from "./subServerTable.vue?vue&type=script&lang=js&"
import style0 from "./subServerTable.vue?vue&type=style&index=0&id=45357d79&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45357d79",
  null
  
)

export default component.exports